/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiLocationBulkUploadPost } from '../fn/location/api-location-bulk-upload-post';
import { ApiLocationBulkUploadPost$Params } from '../fn/location/api-location-bulk-upload-post';
import { apiLocationBulkUploadPost$Plain } from '../fn/location/api-location-bulk-upload-post-plain';
import { ApiLocationBulkUploadPost$Plain$Params } from '../fn/location/api-location-bulk-upload-post-plain';
import { apiLocationCreateLocationPost } from '../fn/location/api-location-create-location-post';
import { ApiLocationCreateLocationPost$Params } from '../fn/location/api-location-create-location-post';
import { apiLocationCreateLocationPost$Plain } from '../fn/location/api-location-create-location-post-plain';
import { ApiLocationCreateLocationPost$Plain$Params } from '../fn/location/api-location-create-location-post-plain';
import { apiLocationDeleteLocationDelete } from '../fn/location/api-location-delete-location-delete';
import { ApiLocationDeleteLocationDelete$Params } from '../fn/location/api-location-delete-location-delete';
import { apiLocationDeleteLocationDelete$Plain } from '../fn/location/api-location-delete-location-delete-plain';
import { ApiLocationDeleteLocationDelete$Plain$Params } from '../fn/location/api-location-delete-location-delete-plain';
import { apiLocationGetAllLocationsPost } from '../fn/location/api-location-get-all-locations-post';
import { ApiLocationGetAllLocationsPost$Params } from '../fn/location/api-location-get-all-locations-post';
import { apiLocationGetAllLocationsPost$Plain } from '../fn/location/api-location-get-all-locations-post-plain';
import { ApiLocationGetAllLocationsPost$Plain$Params } from '../fn/location/api-location-get-all-locations-post-plain';
import { apiLocationGetLocationGet } from '../fn/location/api-location-get-location-get';
import { ApiLocationGetLocationGet$Params } from '../fn/location/api-location-get-location-get';
import { apiLocationGetLocationGet$Plain } from '../fn/location/api-location-get-location-get-plain';
import { ApiLocationGetLocationGet$Plain$Params } from '../fn/location/api-location-get-location-get-plain';
import { apiLocationGetLocationsReportGet } from '../fn/location/api-location-get-locations-report-get';
import { ApiLocationGetLocationsReportGet$Params } from '../fn/location/api-location-get-locations-report-get';
import { apiLocationGetLocationsReportGet$Plain } from '../fn/location/api-location-get-locations-report-get-plain';
import { ApiLocationGetLocationsReportGet$Plain$Params } from '../fn/location/api-location-get-locations-report-get-plain';
import { apiLocationGetSortedLocationsByPlanDateGet } from '../fn/location/api-location-get-sorted-locations-by-plan-date-get';
import { ApiLocationGetSortedLocationsByPlanDateGet$Params } from '../fn/location/api-location-get-sorted-locations-by-plan-date-get';
import { apiLocationGetSortedLocationsByPlanDateGet$Plain } from '../fn/location/api-location-get-sorted-locations-by-plan-date-get-plain';
import { ApiLocationGetSortedLocationsByPlanDateGet$Plain$Params } from '../fn/location/api-location-get-sorted-locations-by-plan-date-get-plain';
import { apiLocationTemplateGet } from '../fn/location/api-location-template-get';
import { ApiLocationTemplateGet$Params } from '../fn/location/api-location-template-get';
import { apiLocationUpdateLocationPatch } from '../fn/location/api-location-update-location-patch';
import { ApiLocationUpdateLocationPatch$Params } from '../fn/location/api-location-update-location-patch';
import { apiLocationUpdateLocationPatch$Plain } from '../fn/location/api-location-update-location-patch-plain';
import { ApiLocationUpdateLocationPatch$Plain$Params } from '../fn/location/api-location-update-location-patch-plain';
import { CreateLocationCommandResult } from '../models/create-location-command-result';
import { CreateLocationsFromExcelSheetResult } from '../models/create-locations-from-excel-sheet-result';
import { DeleteLocationCommandResult } from '../models/delete-location-command-result';
import { GetAllLocationsQueryResult } from '../models/get-all-locations-query-result';
import { GetLocationQueryResult } from '../models/get-location-query-result';
import { GetLocationsReportQueryResult } from '../models/get-locations-report-query-result';
import { GetSortedLocationsByPlanDateQueryResult } from '../models/get-sorted-locations-by-plan-date-query-result';
import { UpdateLocationCommandResult } from '../models/update-location-command-result';

@Injectable({ providedIn: 'root' })
export class LocationService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiLocationGetLocationGet()` */
  static readonly ApiLocationGetLocationGetPath = '/api/Location/GetLocation';

  /**
   * Retrieves a specific location by ID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiLocationGetLocationGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiLocationGetLocationGet$Plain$Response(params?: ApiLocationGetLocationGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetLocationQueryResult>> {
    return apiLocationGetLocationGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieves a specific location by ID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiLocationGetLocationGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiLocationGetLocationGet$Plain(params?: ApiLocationGetLocationGet$Plain$Params, context?: HttpContext): Observable<GetLocationQueryResult> {
    return this.apiLocationGetLocationGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetLocationQueryResult>): GetLocationQueryResult => r.body)
    );
  }

  /**
   * Retrieves a specific location by ID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiLocationGetLocationGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiLocationGetLocationGet$Response(params?: ApiLocationGetLocationGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetLocationQueryResult>> {
    return apiLocationGetLocationGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieves a specific location by ID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiLocationGetLocationGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiLocationGetLocationGet(params?: ApiLocationGetLocationGet$Params, context?: HttpContext): Observable<GetLocationQueryResult> {
    return this.apiLocationGetLocationGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetLocationQueryResult>): GetLocationQueryResult => r.body)
    );
  }

  /** Path part for operation `apiLocationGetAllLocationsPost()` */
  static readonly ApiLocationGetAllLocationsPostPath = '/api/Location/GetAllLocations';

  /**
   * Retrieves all locations with filtering and pagination.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiLocationGetAllLocationsPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiLocationGetAllLocationsPost$Plain$Response(params?: ApiLocationGetAllLocationsPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetAllLocationsQueryResult>> {
    return apiLocationGetAllLocationsPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieves all locations with filtering and pagination.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiLocationGetAllLocationsPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiLocationGetAllLocationsPost$Plain(params?: ApiLocationGetAllLocationsPost$Plain$Params, context?: HttpContext): Observable<GetAllLocationsQueryResult> {
    return this.apiLocationGetAllLocationsPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetAllLocationsQueryResult>): GetAllLocationsQueryResult => r.body)
    );
  }

  /**
   * Retrieves all locations with filtering and pagination.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiLocationGetAllLocationsPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiLocationGetAllLocationsPost$Response(params?: ApiLocationGetAllLocationsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetAllLocationsQueryResult>> {
    return apiLocationGetAllLocationsPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieves all locations with filtering and pagination.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiLocationGetAllLocationsPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiLocationGetAllLocationsPost(params?: ApiLocationGetAllLocationsPost$Params, context?: HttpContext): Observable<GetAllLocationsQueryResult> {
    return this.apiLocationGetAllLocationsPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetAllLocationsQueryResult>): GetAllLocationsQueryResult => r.body)
    );
  }

  /** Path part for operation `apiLocationGetSortedLocationsByPlanDateGet()` */
  static readonly ApiLocationGetSortedLocationsByPlanDateGetPath = '/api/Location/GetSortedLocationsByPlanDate';

  /**
   * Retrieves sorted locations by plan date with filtering .
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiLocationGetSortedLocationsByPlanDateGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiLocationGetSortedLocationsByPlanDateGet$Plain$Response(params?: ApiLocationGetSortedLocationsByPlanDateGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetSortedLocationsByPlanDateQueryResult>> {
    return apiLocationGetSortedLocationsByPlanDateGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieves sorted locations by plan date with filtering .
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiLocationGetSortedLocationsByPlanDateGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiLocationGetSortedLocationsByPlanDateGet$Plain(params?: ApiLocationGetSortedLocationsByPlanDateGet$Plain$Params, context?: HttpContext): Observable<GetSortedLocationsByPlanDateQueryResult> {
    return this.apiLocationGetSortedLocationsByPlanDateGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetSortedLocationsByPlanDateQueryResult>): GetSortedLocationsByPlanDateQueryResult => r.body)
    );
  }

  /**
   * Retrieves sorted locations by plan date with filtering .
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiLocationGetSortedLocationsByPlanDateGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiLocationGetSortedLocationsByPlanDateGet$Response(params?: ApiLocationGetSortedLocationsByPlanDateGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetSortedLocationsByPlanDateQueryResult>> {
    return apiLocationGetSortedLocationsByPlanDateGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieves sorted locations by plan date with filtering .
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiLocationGetSortedLocationsByPlanDateGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiLocationGetSortedLocationsByPlanDateGet(params?: ApiLocationGetSortedLocationsByPlanDateGet$Params, context?: HttpContext): Observable<GetSortedLocationsByPlanDateQueryResult> {
    return this.apiLocationGetSortedLocationsByPlanDateGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetSortedLocationsByPlanDateQueryResult>): GetSortedLocationsByPlanDateQueryResult => r.body)
    );
  }

  /** Path part for operation `apiLocationGetLocationsReportGet()` */
  static readonly ApiLocationGetLocationsReportGetPath = '/api/Location/GetLocationsReport';

  /**
   * Retrieves locations Report.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiLocationGetLocationsReportGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiLocationGetLocationsReportGet$Plain$Response(params?: ApiLocationGetLocationsReportGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetLocationsReportQueryResult>> {
    return apiLocationGetLocationsReportGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieves locations Report.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiLocationGetLocationsReportGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiLocationGetLocationsReportGet$Plain(params?: ApiLocationGetLocationsReportGet$Plain$Params, context?: HttpContext): Observable<GetLocationsReportQueryResult> {
    return this.apiLocationGetLocationsReportGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetLocationsReportQueryResult>): GetLocationsReportQueryResult => r.body)
    );
  }

  /**
   * Retrieves locations Report.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiLocationGetLocationsReportGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiLocationGetLocationsReportGet$Response(params?: ApiLocationGetLocationsReportGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetLocationsReportQueryResult>> {
    return apiLocationGetLocationsReportGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieves locations Report.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiLocationGetLocationsReportGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiLocationGetLocationsReportGet(params?: ApiLocationGetLocationsReportGet$Params, context?: HttpContext): Observable<GetLocationsReportQueryResult> {
    return this.apiLocationGetLocationsReportGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetLocationsReportQueryResult>): GetLocationsReportQueryResult => r.body)
    );
  }

  /** Path part for operation `apiLocationCreateLocationPost()` */
  static readonly ApiLocationCreateLocationPostPath = '/api/Location/CreateLocation';

  /**
   * Creates a new location.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiLocationCreateLocationPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiLocationCreateLocationPost$Plain$Response(params?: ApiLocationCreateLocationPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateLocationCommandResult>> {
    return apiLocationCreateLocationPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Creates a new location.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiLocationCreateLocationPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiLocationCreateLocationPost$Plain(params?: ApiLocationCreateLocationPost$Plain$Params, context?: HttpContext): Observable<CreateLocationCommandResult> {
    return this.apiLocationCreateLocationPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreateLocationCommandResult>): CreateLocationCommandResult => r.body)
    );
  }

  /**
   * Creates a new location.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiLocationCreateLocationPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiLocationCreateLocationPost$Response(params?: ApiLocationCreateLocationPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateLocationCommandResult>> {
    return apiLocationCreateLocationPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Creates a new location.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiLocationCreateLocationPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiLocationCreateLocationPost(params?: ApiLocationCreateLocationPost$Params, context?: HttpContext): Observable<CreateLocationCommandResult> {
    return this.apiLocationCreateLocationPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreateLocationCommandResult>): CreateLocationCommandResult => r.body)
    );
  }

  /** Path part for operation `apiLocationUpdateLocationPatch()` */
  static readonly ApiLocationUpdateLocationPatchPath = '/api/Location/UpdateLocation';

  /**
   * Updates an existing location.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiLocationUpdateLocationPatch$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiLocationUpdateLocationPatch$Plain$Response(params?: ApiLocationUpdateLocationPatch$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateLocationCommandResult>> {
    return apiLocationUpdateLocationPatch$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Updates an existing location.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiLocationUpdateLocationPatch$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiLocationUpdateLocationPatch$Plain(params?: ApiLocationUpdateLocationPatch$Plain$Params, context?: HttpContext): Observable<UpdateLocationCommandResult> {
    return this.apiLocationUpdateLocationPatch$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<UpdateLocationCommandResult>): UpdateLocationCommandResult => r.body)
    );
  }

  /**
   * Updates an existing location.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiLocationUpdateLocationPatch()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiLocationUpdateLocationPatch$Response(params?: ApiLocationUpdateLocationPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateLocationCommandResult>> {
    return apiLocationUpdateLocationPatch(this.http, this.rootUrl, params, context);
  }

  /**
   * Updates an existing location.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiLocationUpdateLocationPatch$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiLocationUpdateLocationPatch(params?: ApiLocationUpdateLocationPatch$Params, context?: HttpContext): Observable<UpdateLocationCommandResult> {
    return this.apiLocationUpdateLocationPatch$Response(params, context).pipe(
      map((r: StrictHttpResponse<UpdateLocationCommandResult>): UpdateLocationCommandResult => r.body)
    );
  }

  /** Path part for operation `apiLocationDeleteLocationDelete()` */
  static readonly ApiLocationDeleteLocationDeletePath = '/api/Location/DeleteLocation';

  /**
   * Deletes a location by ID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiLocationDeleteLocationDelete$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiLocationDeleteLocationDelete$Plain$Response(params?: ApiLocationDeleteLocationDelete$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteLocationCommandResult>> {
    return apiLocationDeleteLocationDelete$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Deletes a location by ID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiLocationDeleteLocationDelete$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiLocationDeleteLocationDelete$Plain(params?: ApiLocationDeleteLocationDelete$Plain$Params, context?: HttpContext): Observable<DeleteLocationCommandResult> {
    return this.apiLocationDeleteLocationDelete$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeleteLocationCommandResult>): DeleteLocationCommandResult => r.body)
    );
  }

  /**
   * Deletes a location by ID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiLocationDeleteLocationDelete()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiLocationDeleteLocationDelete$Response(params?: ApiLocationDeleteLocationDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteLocationCommandResult>> {
    return apiLocationDeleteLocationDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Deletes a location by ID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiLocationDeleteLocationDelete$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiLocationDeleteLocationDelete(params?: ApiLocationDeleteLocationDelete$Params, context?: HttpContext): Observable<DeleteLocationCommandResult> {
    return this.apiLocationDeleteLocationDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeleteLocationCommandResult>): DeleteLocationCommandResult => r.body)
    );
  }

  /** Path part for operation `apiLocationTemplateGet()` */
  static readonly ApiLocationTemplateGetPath = '/api/Location/template';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiLocationTemplateGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiLocationTemplateGet$Response(params?: ApiLocationTemplateGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiLocationTemplateGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiLocationTemplateGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiLocationTemplateGet(params?: ApiLocationTemplateGet$Params, context?: HttpContext): Observable<void> {
    return this.apiLocationTemplateGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiLocationBulkUploadPost()` */
  static readonly ApiLocationBulkUploadPostPath = '/api/Location/bulk-upload';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiLocationBulkUploadPost$Plain()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiLocationBulkUploadPost$Plain$Response(params?: ApiLocationBulkUploadPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateLocationsFromExcelSheetResult>> {
    return apiLocationBulkUploadPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiLocationBulkUploadPost$Plain$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiLocationBulkUploadPost$Plain(params?: ApiLocationBulkUploadPost$Plain$Params, context?: HttpContext): Observable<CreateLocationsFromExcelSheetResult> {
    return this.apiLocationBulkUploadPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreateLocationsFromExcelSheetResult>): CreateLocationsFromExcelSheetResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiLocationBulkUploadPost()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiLocationBulkUploadPost$Response(params?: ApiLocationBulkUploadPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateLocationsFromExcelSheetResult>> {
    return apiLocationBulkUploadPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiLocationBulkUploadPost$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiLocationBulkUploadPost(params?: ApiLocationBulkUploadPost$Params, context?: HttpContext): Observable<CreateLocationsFromExcelSheetResult> {
    return this.apiLocationBulkUploadPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreateLocationsFromExcelSheetResult>): CreateLocationsFromExcelSheetResult => r.body)
    );
  }

}
